var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMuted = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  className: "icon",
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M767.99 677.517V21.371a21.333 21.333 0 0 0-36.436-15.103L414.17 323.696zm164.431 224.717L121.785 91.598a21.333 21.333 0 0 0-30.164 30.164L311.176 341.36h-76.499a21.333 21.333 0 0 0-21.332 21.333v298.655a21.333 21.333 0 0 0 21.332 21.333h161.829l335.091 335.09a21.333 21.333 0 0 0 36.393-15.103V798.174l134.225 134.224a21.333 21.333 0 1 0 30.206-30.164"
})));
export { SvgMuted as ReactComponent };
export default "/_next/static/images/muted.svg";